import { AppLoaderDto } from "../../core/dto/generic.dto";

const AppLoader = ({ removeFixedHeight, customClassName, customStyle }: AppLoaderDto) => {
    let fixedHeightClassName = removeFixedHeight ? "" : " app-Fixed-height";
    if (customClassName) {
        fixedHeightClassName = `${fixedHeightClassName} ${customClassName}`;
    }
    let loaderClassName =
        "text-center spinner-block d-flex align-items-center justify-content-center " +
        fixedHeightClassName;
    
    return (
        <>
            <div className={loaderClassName} style={customStyle ? customStyle : {}}>
                <div className="spinner spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </>
    );
};

export default AppLoader;
